import { cva } from "class-variance-authority";

const loading = cva(["absolute", "inline-flex", "items-center"], {
  variants: {
    variant: {
      primary: ["border-white"],
      secondary: ["border-neutral-950"],
      destructive: ["border-white"],
      ghost: ["border-neutral-950"],
      link: ["border-indigo-500"],
    },
  },
});

const Loading = ({ variant }) => (
  <div className={loading({ variant })}>
    <div className="w-4 h-4 rounded-full border-2 border-b-transparent animate-spin border-[inherit]" />
  </div>
);

export default Loading;
